import { call, put, takeLatest } from "redux-saga/effects";
import apiCall from "../services"
import config from '../config/config.json';

const endpoint = `${config.credentials.url}/financing-discount`;

function* getFinancingDiscountList(actions) {
    try {
        const headers = {
            "Content-Type": "application/json",
            Authorization: `Bearer ${actions.access}`,
        };

        const query = actions.query ? actions.query : "";
        const url = `${endpoint}/${query}`;

        const response = yield call(
            apiCall,
            "GET",
            url,
            { headers }
        );

        yield put({
            type: "FINANCING_DISCOUNT_LIST_RESPONSE",
            value: response,
        });

    } catch (error) {
        yield put({
            type: "FINANCING_DISCOUNT_ERROR",
            error,
        });
    }
}

function* getFinancingDiscountDetail(actions) {
    try {
        const headers = {
            "Content-Type": "application/json",
            Authorization: `Bearer ${actions.access}`,
        };

        const url = `${endpoint}/${actions.id}/`;

        const response = yield call(
            apiCall,
            "GET",
            url,
            { headers }
        );

        yield put({
            type: "FINANCING_DISCOUNT_DETAIL_RESPONSE",
            value: response,
        });

    } catch (error) {
        yield put({
            type: "FINANCING_DISCOUNT_ERROR",
            error,
        });
    }
}

function* createFinancingDiscount(actions) {
    try {
        const headers = {
            "Content-Type": "application/json",
            Authorization: `Bearer ${actions.access}`,
        };

        const requestOptions = {
            headers,
            body: JSON.stringify(actions.payload),
        };

        console.log("SENDING POST PAYLOAD:", requestOptions.body);

        const response = yield call(
            apiCall,
            "POST",
            `${endpoint}/`,
            requestOptions
        );

        yield put({
            type: "FINANCING_DISCOUNT_CREATE_RESPONSE",
            value: response,
        });
    } catch (error) {
        console.error("CREATE FINANCING DISCOUNT ERROR:", error);
        yield put({
            type: "FINANCING_DISCOUNT_CREATE_ERROR",
            error,
        });
    }
}

function* updateFinancingDiscount(actions) {
    try {
        const headers = {
            "Content-Type": "application/json",
            Authorization: `Bearer ${actions.access}`,
        };

        const requestOptions = {
            headers,
            body: JSON.stringify(actions.payload),
        };

        const response = yield call(
            apiCall,
            "PATCH",
            `${endpoint}/${actions.id}/`,
            requestOptions
        );

        yield put({
            type: "FINANCING_DISCOUNT_UPDATE_RESPONSE",
            value: response,
        });
    } catch (error) {
        yield put({
            type: "FINANCING_DISCOUNT_UPDATE_ERROR",
            error,
        });
    }
}

export default function* sagaFinancingDiscount() {
    yield takeLatest("FINANCING_DISCOUNT_LIST_REQUEST", getFinancingDiscountList);
    yield takeLatest("FINANCING_DISCOUNT_DETAIL_REQUEST", getFinancingDiscountDetail);
    yield takeLatest("FINANCING_DISCOUNT_CREATE_REQUEST", createFinancingDiscount);
    yield takeLatest("FINANCING_DISCOUNT_UPDATE_REQUEST", updateFinancingDiscount);
}
